<template>
  <div>
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="item in msg" :key="item.id">
          <img :src="item.imgUrl" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";

export default {
  name: "Swiper",
  props: {
    msg: {
      type: Array,
    },
  },
  data() {
    return {};
  },
  mounted() {
    setTimeout(() => {
      new Swiper(".swiper-container", {
        loop: false,
        autoplay:false,
      });
    }, 500);
  },
  components: {},
};
</script>

<style scoped>
.swiper-container {
  height: 97vh;
  width: 100%;
}

.swiper-slide img {
  width: 100%;
  height: 100%;
}
</style>
